import React from 'react';
import { Input, Select, Row, Col } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { MigrationFilters, ConversionType, BuyingModelFilter } from '../types';
import {
  CONVERSION_LABELS,
  CONVERSION_BUYING_MODEL_FILTER,
  BUYING_MODEL_OPTIONS,
} from '../constants';

const { Option } = Select;

interface Props {
  filters:    MigrationFilters;
  setFilters: (f: MigrationFilters) => void;
}

const conversionOptions: { label: string; value: ConversionType }[] = [
  { label: CONVERSION_LABELS.none,      value: 'none'      },
  { label: CONVERSION_LABELS.clone,     value: 'clone'     },
  { label: CONVERSION_LABELS.alc_to_ea, value: 'alc_to_ea' },
  { label: CONVERSION_LABELS.ea_to_alc, value: 'ea_to_alc' },
];

const SkuFilterBar: React.FC<Props> = ({ filters, setFilters }) => {
  const handleConversionChange = (value: ConversionType) => {
    setFilters({
      ...filters,
      conversionType:    value,
      buyingModelFilter: CONVERSION_BUYING_MODEL_FILTER[value],
    });
  };

  return (
    <Row gutter={[12, 12]} align="middle" style={{ marginBottom: 16 }}>
      <Col xs={24} sm={8} md={7}>
        {/* <div style={{ marginBottom: 4, fontSize: 12 }}>Convertion Type</div> */}
        <Select<ConversionType>
          value={filters.conversionType}
          onChange={handleConversionChange}
          style={{ width: '100%' }}
          placeholder="Conversion type"
          data-testid="conversion-type-select"
        >
          {conversionOptions.map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {opt.label}
            </Option>
          ))}
        </Select>
      </Col>

      <Col xs={24} sm={7} md={6}>
        <Select<BuyingModelFilter>
          value={filters.buyingModelFilter}
          onChange={(value) => setFilters({ ...filters, buyingModelFilter: value })}
          style={{ width: '100%' }}
          placeholder="Buying model"
        >
          {BUYING_MODEL_OPTIONS.map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {opt.label}
            </Option>
          ))}
        </Select>
      </Col>

      <Col xs={24} sm={9} md={11}>
        <Input
          allowClear
          placeholder="Search SKU name…"
          prefix={<SearchOutlined />}
          value={filters.searchText}
          onChange={(e) => setFilters({ ...filters, searchText: e.target.value })}
          data-testid="sku-search-input"
        />
      </Col>
    </Row>
  );
};

export default SkuFilterBar;
